export default __webpack_public_path__ + "static/health-ehr-solution-8b75dcce2655cc22a37659266e6b02c9.png";